import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/api.service';
import { ToastService } from '../services/toast.service';
import { LoadingService } from '../services/loading.service';

@Component({
  selector: 'app-subir-archivo',
  templateUrl: './subir-archivo.component.html',
  styleUrls: ['./subir-archivo.component.css'],
})
export class SubirArchivoComponent implements OnInit {
  tiposArchivo: string[] = [];
  archivosSeleccionados: string[] = [];
  obraSocialSeleccionada: string = '';
  obrasSociales: any[] = [];
  archivos: { archivo: File | null; tipo: string; nombre: string }[] = [];

  mesSeleccionado: (number | null)[] = [];
  anioSeleccionado: (number | null)[] = [];
  mesesDisponibles: Array<{ valor: number; texto: string }[]> = [];

  meses: string[] = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ];
  aniosDisponibles: number[] = [];

  constructor(
    private apiSrv: ApiService,
    private toastSrv: ToastService,
    private loadingSrv: LoadingService
  ) {
    const anioActual = new Date().getFullYear();
    for (let anio = 2000; anio <= anioActual; anio++) {
      this.aniosDisponibles.push(anio);
    }
    this.aniosDisponibles.reverse();
  }

  ngOnInit(): void {
    this.obtenerObrasSociales();
    this.inicializarSelectores();
  }

  inicializarSelectores(): void {
    const cantidadSelectores = this.tiposArchivo.length || 1;

    for (let i = 0; i < cantidadSelectores; i++) {
      this.mesSeleccionado[i] = null;
      this.anioSeleccionado[i] = null;

      this.actualizarMesesDisponibles(i);
    }
  }

  obtenerPeriodoFormateado(index: number): string {
    if (!this.mesSeleccionado[index] || !this.anioSeleccionado[index]) {
      return 'No seleccionado';
    }

    const anio = this.anioSeleccionado[index];
    const mes = this.mesSeleccionado[index];
    const mesFormateado = mes < 10 ? '0' + mes : '' + mes;
    return `${anio}${mesFormateado}`;
  }

  obtenerPeriodoLong(index: number): number {
    if (!this.mesSeleccionado[index] || !this.anioSeleccionado[index]) {
      return 0;
    }

    const anio = this.anioSeleccionado[index];
    const mes = this.mesSeleccionado[index];

    return anio * 100 + mes;
  }

  seleccionarArchivo(event: any, index: number): void {
    const archivo = event.target.files[0];
    if (archivo) {
      this.archivosSeleccionados[index] = archivo.name;
      this.archivos[index] = {
        archivo,
        tipo: this.tiposArchivo[index],
        nombre: archivo.name,
      };
    }
  }

  eliminarArchivo(index: number): void {
    this.archivosSeleccionados[index] = 'Seleccione un Archivo';
    this.archivos[index] = {
      archivo: null,
      tipo: this.tiposArchivo[index],
      nombre: '',
    };
  }

  subirArchivos(): void {
    if (this.archivos.length === 0) {
      this.toastSrv.mostrarNotificacion(
        'Debe seleccionar al menos un archivo',
        'error'
      );
      return;
    }

    if (!this.obraSocialSeleccionada) {
      this.toastSrv.mostrarNotificacion(
        'Debe seleccionar una obra social',
        'error'
      );
      return;
    }

    if (!this.validarPeriodoSiEsRequerido()) {
      return;
    }

    const periodoPercibido = this.obtenerPeriodoPercibidoParaEnvio();

    const archivosAEnviar = this.prepararArchivosParaEnvio();
    this.loadingSrv.setLoading(true);

    this.apiSrv
      .subirArchivos(
        archivosAEnviar,
        this.obraSocialSeleccionada,
        periodoPercibido
      )
      .subscribe(
        this.manejarRespuestaExitosa.bind(this),
        this.manejarRespuestaError.bind(this)
      );
  }

  manejarRespuestaExitosa(respuesta: any): void {
    this.loadingSrv.setLoading(false);
    const cod = respuesta.cod;
    const descripcion =
      respuesta.descripcion || 'Archivos procesados exitosamente';
    const errores = respuesta.errores || [];

    if (cod === 0 && errores.length > 0) {
      let errorMessage = descripcion + '<br>';
      const erroresMensajes = errores.map(
        (err: { mensajeError: string }) => err.mensajeError
      );
      errorMessage += erroresMensajes.join('<br>');
      this.toastSrv.mostrarNotificacion(
        `Archivos procesados con algunos errores:<br>${errorMessage}`,
        'warning'
      );
    } else if (cod === 1) {
      this.toastSrv.mostrarNotificacion(`${descripcion}`, 'success');
    } else {
      this.toastSrv.mostrarNotificacion(`${descripcion}`, 'info');
    }

    this.limpiarArchivos();
  }

  manejarRespuestaError(error: any): void {
    this.loadingSrv.setLoading(false);
    const errorObject = error?.error || {};
    const descripcion = errorObject.descripcion || 'Error desconocido';
    const errores = errorObject.errores || [];

    let errorMessage = descripcion;
    if (errores.length > 0) {
      const erroresMensajes = errores.map(
        (err: { mensajeError: string }) => err.mensajeError
      );
      errorMessage += '<br>' + erroresMensajes.join('<br>');
    }

    this.toastSrv.mostrarNotificacion(
      `Error al subir los archivos:<br>${errorMessage}`,
      'error'
    );
  }

  limpiarArchivos(): void {
    this.archivos = [];
    this.archivosSeleccionados = this.tiposArchivo.map(
      () => 'Seleccione un Archivo'
    );
  }

  validarPeriodo(index: number): boolean {
    if (!this.mesSeleccionado[index] || !this.anioSeleccionado[index]) {
      this.toastSrv.mostrarNotificacion(
        'Debe seleccionar un período válido (mes y año)',
        'error'
      );
      return false;
    }
    return true;
  }

  validarPeriodoSiEsRequerido(): boolean {
    if (!this.requiereSelectorPeriodo()) {
      return true;
    }

    if (this.hayArchivoAportesSeleccionado()) {
      const indiceAportes = this.encontrarIndiceArchivoAportes();

      if (
        !this.mesSeleccionado[indiceAportes] ||
        !this.anioSeleccionado[indiceAportes]
      ) {
        this.toastSrv.mostrarNotificacion(
          'Para archivos de tipo Aportes en obras sociales OSCEARA y NAVAL, debe seleccionar un período (mes y año)',
          'error'
        );
        return false;
      }
    }

    return true;
  }

  encontrarIndiceArchivoAportes(): number {
    return this.tiposArchivo.findIndex(
      (tipo) => tipo.toLowerCase() === 'aportes'
    );
  }

  obtenerPeriodoPercibido(): number {
    const indiceAportes = this.encontrarIndiceArchivoAportes();

    if (indiceAportes === -1) {
      return 0;
    }

    if (!this.validarPeriodo(indiceAportes)) {
      return 0;
    }

    const anio = Number(this.anioSeleccionado[indiceAportes]);
    const mes = Number(this.mesSeleccionado[indiceAportes]);

    // Forzar la converración matemática correctamente
    const resultado = anio * 100 + mes;

    return resultado;
  }

  hayArchivoAportesSeleccionado(): boolean {
    const indiceAportes = this.encontrarIndiceArchivoAportes();
    if (indiceAportes === -1) {
      return false;
    }

    return this.archivos[indiceAportes]?.archivo !== null;
  }

  obtenerPeriodoPercibidoParaEnvio(): number {
    if (
      !this.requiereSelectorPeriodo() ||
      !this.hayArchivoAportesSeleccionado()
    ) {
      return 0;
    }

    const indiceAportes = this.encontrarIndiceArchivoAportes();

    if (
      !this.mesSeleccionado[indiceAportes] ||
      !this.anioSeleccionado[indiceAportes]
    ) {
      return 0;
    }

    const anio = Number(this.anioSeleccionado[indiceAportes]);
    const mes = Number(this.mesSeleccionado[indiceAportes]);

    return anio * 100 + mes;
  }

  obtenerDescripcionObraSocial(idObraSocial: string): string {
    const obraSocial = this.obrasSociales.find(
      (os) => os.id.toString() === idObraSocial
    );

    return obraSocial ? obraSocial.descripcion : '';
  }

  requiereSelectorPeriodo(): boolean {
    const descripcion = this.obtenerDescripcionObraSocial(
      this.obraSocialSeleccionada
    ).toUpperCase();
    return descripcion === 'OSCEARA' || descripcion === 'NAVAL';
  }

  requiereSelectorPeriodoParaTipo(tipo: string): boolean {
    if (!this.requiereSelectorPeriodo()) {
      return false;
    }
    return tipo.toLowerCase() === 'aportes';
  }

  prepararArchivosParaEnvio(): { archivo: File; tipo: string }[] {
    return this.archivos
      .filter((archivo) => archivo.archivo !== null)
      .map((archivo) => ({
        archivo: archivo.archivo as File,
        tipo: archivo.tipo,
      }));
  }

  obtenerObrasSociales(): void {
    this.apiSrv.obtenerObrasSociales().subscribe(
      (data: any[]) => {
        this.obrasSociales = data;
      },
      (error) => {
        console.error('Error al obtener las obras sociales:', error);
      }
    );
  }

  onObraSocialChange(): void {
    if (this.obraSocialSeleccionada) {
      this.apiSrv
        .obtenerDescripcionesEnumPorCodigo(Number(this.obraSocialSeleccionada))
        .subscribe(
          (data: any[]) => {
            this.tiposArchivo = data;
            this.archivosSeleccionados = this.tiposArchivo.map(
              () => 'Seleccione un Archivo'
            );
            this.archivos = this.tiposArchivo.map(() => ({
              archivo: null,
              tipo: '',
              nombre: '',
            }));
            this.inicializarSelectores();
          },
          (error) => {
            console.error('Error al obtener los tipos de archivo:', error);
          }
        );
    } else {
      this.tiposArchivo = [];
      this.archivosSeleccionados = [];
      this.archivos = [];
      this.mesSeleccionado = [];
      this.anioSeleccionado = [];
    }
  }

  triggerFileInput(index: number): void {
    const fileInput = document.querySelectorAll('input[type="file"]')[
      index
    ] as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  hayArchivosSeleccionados(): boolean {
    return this.archivosSeleccionados.some(
      (archivo) => archivo !== 'Seleccione un Archivo'
    );
  }

  actualizarMesesDisponibles(index: number): void {
    const fechaActual = new Date();
    const mesActual = fechaActual.getMonth() + 1;
    const anioActual = fechaActual.getFullYear();

    if (this.anioSeleccionado[index] === anioActual) {
      this.mesesDisponibles[index] = this.meses
        .slice(0, mesActual)
        .map((mes, i) => ({ valor: i + 1, texto: mes }));

      if (
        this.mesSeleccionado[index] !== null &&
        this.mesSeleccionado[index] > mesActual
      ) {
        this.mesSeleccionado[index] = mesActual;
      }
    } else {
      this.mesesDisponibles[index] = this.meses.map((mes, i) => ({
        valor: i + 1,
        texto: mes,
      }));
    }
  }

  getMesesDisponiblesParaIndice(
    index: number
  ): { valor: number; texto: string }[] {
    if (!this.mesesDisponibles[index]) {
      this.actualizarMesesDisponibles(index);
    }
    return this.mesesDisponibles[index] || [];
  }

  onAnioChange(index: number): void {
    this.actualizarMesesDisponibles(index);
  }
}
